<div class="container-panel">
  <!-- Orientation Lines -->
  <div
    *ngFor="let line of orientationLines$ | async"
    class="orientation-line"
    [class.vertical]="line.type === 'vertical'"
    [class.horizontal]="line.type === 'horizontal'"
    [ngStyle]="{
      left: line.x + 'px',
      top: line.y + 'px',
      width: line.width + 'px',
      height: line.height + 'px',
    }"
  ></div>

  <div
    *ngFor="let rect of containerRectangles$ | async"
    class="container-rect"
    [ngClass]="{
      'ct-hover': rect.state == 'hover',
      'ct-active': rect.state == 'active',
      'ct-passive': rect.state == 'passive',
    }"
    [ngStyle]="{
      left: rect.alignment?.x + 'px',
      top: rect.alignment?.y + 'px',
      width: rect.alignment?.w + 'px',
      height: rect.alignment?.h + 'px',
    }"
    (click)="rect.state == 'hover' && click(rect.IRI)"
  ></div>

  <ng-container *ngFor="let menu of containerMenus$ | async">
    <div
      class="menu-container"
      [style.width.px]="menu.w"
      [style.height.px]="menu.h"
      [style.border]="menu.state != 'hidden' ? '1px solid #0191f3' : 'none'"
      [ngStyle]="{
        left: menu.x + 'px',
        top: menu.y + 'px',
        'pointer-events': menu.state == 'active' ? 'none' : 'auto',
      }"
      (mouseenter)="containerMouseOver($event, menu)"
      (mouseleave)="containerMouseOut($event, menu)"
      (click)="containerMenuClick($event, menu)"
    ></div>
    <ng-container *ngIf="isMenuHovered == menu.IRI">
      <div class="container" [ngStyle]="topCenterPosition(menu)">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addAbove(menu.IRI)"
          matTooltip="Add above"
        ></nw-icon>
      </div>
      <div class="container" [ngStyle]="leftCenterPosition(menu)">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addPrev(menu.IRI)"
          matTooltip="Add before"
        ></nw-icon>
      </div>
      <div class="container" [ngStyle]="bottomCenterPosition(menu)">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addBelow(menu.IRI)"
          matTooltip="Add below"
        ></nw-icon>
      </div>
      <div class="container" [ngStyle]="rightCenterPosition(menu)">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addNext(menu.IRI)"
          matTooltip="Add after"
        ></nw-icon>
      </div>
      <div class="container" [ngStyle]="closeIconPosition(menu)">
        <nw-icon
          type="close"
          color="white"
          [size]="12"
          (click)="removeContainerMenuItem(menu.IRI)"
          matTooltip="Remove cell"
        ></nw-icon>
      </div>
    </ng-container>

    <!-- Container shape action icons for placeholder shapes -->
    <div
      *ngIf="menu.type == 'placeholder'"
      class="container-actions"
      [ngStyle]="{
        left: menu.x + menu.w / 2 - 60 + 'px',
        top: menu.y + menu.h / 2 - 10 + 'px',
      }"
    >
      <div class="flex-row gap-8">
        <!-- Add Image Shape -->
        <nw-icon
          type="image"
          [outlined]="true"
          color="white"
          [size]="16"
          matTooltip="Add Image"
          (click)="addImageShape(menu.IRI)"
        ></nw-icon>

        <!-- Add Text Shape -->
        <div
          class="text-icon"
          matTooltip="Add Text"
          (click)="addTextShape(menu.IRI)"
        >
          T
        </div>

        <!-- Add Row -->
        <nw-icon
          type="splitscreen"
          color="white"
          [size]="16"
          [rotate]="90"
          matTooltip="Add Row"
          (click)="addRow(menu.IRI)"
        ></nw-icon>

        <!-- Add Column -->
        <nw-icon
          type="splitscreen"
          color="white"
          [size]="16"
          matTooltip="Add Column"
          (click)="addColumn(menu.IRI)"
        ></nw-icon>
      </div>
    </div>
  </ng-container>

  <!-- Separate drag and drop overlays based on absolute cell alignments -->
  <!-- Only show when files are being dragged -->
  <!-- <ng-container *ngIf="isFileDragActive"> -->
  <!-- <ng-container
    *ngFor="let alignment of absoluteCellAlignments$ | async | keyvalue"
  >
    <div
      *ngIf="isPlaceholderShape(alignment.key)"
      class="absolute-drop-zone"
      [class.dragging]="dragHoverStates[alignment.key]"
      [class.file-drag-active]="isFileDragActive"
      [ngStyle]="{
        left: getAbsoluteX(alignment.value) + 'px',
        top: getAbsoluteY(alignment.value) + 'px',
        width: getScaledWidth(alignment.value) + 'px',
        height: getScaledHeight(alignment.value) + 'px',
      }"
      (dragover)="onDragOver($event, alignment.key)"
      (dragleave)="onDragLeave($event, alignment.key)"
      (drop)="onDrop($event, alignment.key)"
      [attr.data-container-iri]="alignment.key"
    >
  </div>
</ng-container> -->
  <!-- Visual feedback for drag over -->
  <!-- <div class="drop-overlay" [class.active]="dragHoverStates[alignment.key]">
  <div class="drop-indicator">
    <mat-icon>image</mat-icon>
    <span>Drop image here</span>
  </div>
</div> -->
  <!-- </ng-container> -->

  <!-- <div
    *ngFor="let menu of containerMenus$ | async"
    class="container"
    [ngStyle]="{ left: menu.position[0] + 'px', top: menu.position[1] + 'px' }"
    (mouseenter)="mouseOver(menu.IRI)"
    (mouseleave)="mouseOut()"
  >
    <ng-container [ngSwitch]="menu.type">
      <div *ngSwitchCase="'add-before'">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addBefore(menu.IRI)"
          matTooltip="Add before"
        ></nw-icon>
      </div>
      <div *ngSwitchCase="'add-after'">
        <nw-icon
          type="add"
          color="white"
          [size]="13"
          (click)="addAfter(menu.IRI)"
          matTooltip="Add after"
        ></nw-icon>
      </div>
      <div *ngSwitchCase="'remove'">
        <nw-icon
          type="close"
          color="white"
          [size]="13"
          matTooltip="Remove cell"
          (click)="removeElement(menu.IRI)"
        ></nw-icon>
      </div>
      <div *ngSwitchCase="'add-shape'" class="flex-row gap-8">
        <nw-icon
          type="image"
          [outlined]="true"
          [size]="20"
          matTooltip="Image"
        ></nw-icon>
        <div
          class="text-icon"
          matTooltip="Text"
          (click)="addTextShape(menu.IRI)"
        >
          T
        </div>
        <nw-icon
          type="splitscreen"
          [size]="16"
          [rotate]="90"
          matTooltip="Row"
          (click)="addRow(menu.IRI)"
        ></nw-icon>
        <nw-icon
          (click)="$event.stopPropagation()"
          [size]="16"
          type="splitscreen"
          matTooltip="Column"
          (click)="addColumn(menu.IRI)"
        ></nw-icon>
      </div>
    </ng-container>
  </div> -->

  <!-- <ng-container *ngIf="!baseMode">
      <div class="flex-row gap-8">
        <nw-icon
          type="image"
          [outlined]="true"
          [size]="20"
          matTooltip="Image"
        ></nw-icon>
        <div class="text-icon" matTooltip="Text" (click)="addTextShape()">
          T
        </div>
        <nw-icon
          (click)="$event.stopPropagation()"
          type="splitscreen"
          [size]="16"
          [rotate]="90"
          matTooltip="Row"
        ></nw-icon>
        <nw-icon
          (click)="$event.stopPropagation()"
          [size]="16"
          type="splitscreen"
          matTooltip="Column"
        ></nw-icon>
      </div>
    </ng-container> -->
  <!-- </div> -->
</div>
